import { Component, ViewChild } from '@angular/core';
import { NavController, Nav } from 'ionic-angular';
import { ScreenPage } from '../screen/screen';
import { ConfigProvider } from '../../providers/config/config';
import { AppState } from '../../config/state';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild('subnav') nav: Nav;
  rootPage:any;
  viewType: any;

  constructor(public navCtrl: NavController, private config: ConfigProvider, private state: AppState) {
    this.viewType = this.state.mode;
    // this.deeplinks.routeWithNavController(this.navCtrl, {
    //   '/test': HomePage,
    // }).subscribe((match) => {
    //     // match.$route - the route we matched, which is the matched entry from the arguments to route()
    //     // match.$args - the args passed in the link
    //     // match.$link - the full link data
    //     console.log('Successfully matched route', match);
    //   }, (nomatch) => {
    //     // nomatch.$link - the full link data
    //     console.error('Got a deeplink that didn\'t match', nomatch);
    //   });
    // this.deeplinks.route({
    //   '/discover': DiscoverPage,
    // }).subscribe((match) => {
    //   // match.$route - the route we matched, which is the matched entry from the arguments to route()
    //   // match.$args - the args passed in the link
    //   // match.$link - the full link data
    //   console.log('Successfully matched route', match);
    // }, (noMatch) => {
    //   // noMatch.$link - the full link data
    //   console.error('Got a deeplink that didn\'t match', noMatch);
    // });
    this.config.load(this.state.appId).then(cfg=>{
      this.nav.setRoot(ScreenPage, {screenData:cfg.screens.find(screen=>screen.name=='home')})
    });
  }
  goToPage(page){
    // this.nav.setRoot(HomePage);

  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts